import SEO from '@components/SEO'
import images from '@assets/images'
import BlurImage from '@components/BlurImage'
import { BLUR_HASH_MAP } from '@constants/BlurHashItems'
import './BrochurePage.css'

const BROCHURE_IMAGES = [
  images.brochure1,
  images.brochure2,
  images.brochure3,
  images.brochure4,
  images.brochure5,
  images.brochure6,
  images.brochure7,
  images.brochure8,
  images.brochure9,
  images.brochure10,
  images.brochure11,
  images.brochure12,
  images.brochure13,
  images.brochure14,
  images.brochure15,
  images.brochure16,
  images.brochure17,
  images.brochure18,
  images.brochure19,
  images.brochure20,
  images.brochure21,
  images.brochure22,
  images.brochure23,
  images.brochure24,
  images.brochure25,
  images.brochure26,
  images.brochure27,
  images.brochure28,
  images.brochure29,
  images.brochure30,
  images.brochure31,
  images.brochure32,
  images.brochure33,
  images.brochure34,
  images.brochure35,
  images.brochure36,
  images.brochure37,
]

function BrochurePage() {
  return (
    <main className="brochure-page">
      <SEO
        title="Brochure & Tài liệu – Fenica"
        description="Tài liệu Brochure chính thức cùng Hồ sơ thiết kế chi tiết dự án Fenica."
      />

      <div className="brochure-page__images">
        {BROCHURE_IMAGES.map((src, index) => (
          <BlurImage
            key={index}
            hash={BLUR_HASH_MAP.brochure}
            src={src}
            alt={`Brochure trang ${index + 1}`}
            className="brochure-page__image"
            loading={index === 0 ? 'eager' : 'lazy'}
            wrapperStyle={{ width: '100%' }}
          />
        ))}
      </div>
    </main>
  )
}

export default BrochurePage
